import {
  CSSProperties,
  DetailedHTMLProps,
  DOMAttributes,
  ElementType,
  HTMLAttributes,
} from 'react';

import PropTypes, { Validator } from 'prop-types';
import { CSSProp } from 'styled-components';

/**
 * @deprecated Please update to import from @adsk/alloy-react-theme
 */
export const asPropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.elementType,
]) as Validator<ElementType>;

/**
 * @deprecated Please update to import from @adsk/alloy-react-theme
 */
export const stylePropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.object,
  PropTypes.array,
]) as Validator<CSSProp>;

/**
 * @deprecated Please update to import from @adsk/alloy-react-theme
 */
export type StylableComponent<
  Tag,
  Attributes extends DOMAttributes<Tag> = HTMLAttributes<Tag>,
> = Omit<Attributes, 'style' | 'css'> & {
  as?: ElementType;
  style?: CSSProp | null;
};

/**
 * @deprecated Please update to import from @adsk/alloy-react-theme
 */
export type DetailedStylableComponent<
  Attributes extends HTMLAttributes<Tag>,
  Tag,
  DetailedAttributes = DetailedHTMLProps<Attributes, Tag>,
> = Omit<DetailedAttributes, 'style' | 'css'> & {
  as?: ElementType;
  style?: CSSProp | null;
};

/**
 * @deprecated Please update to import from @adsk/alloy-react-theme
 * Type used for render props
 *
 * ```typescript
 * type MyComponentProps = StylableComponent<HTMLDivElement> & {
 * renderBody?: (props: StylableRenderPropType) => ReactElement;
 * }
 * ```
 */
export type StylableRenderPropType = { style: CSSProperties };
